import React, { ReactNode } from "react";
import "../../assets/scss/generic/loader.scss";

export interface ILoaderProps {
  color?: string;
  size: number;
}

export const SLoader = (size: number, color: string): ReactNode => {
  return (
    <div className="loaderWrap">
      <Loader color={color} size={size} />
    </div>
  );
};

const Loader: React.FC<ILoaderProps> = (props: ILoaderProps) => {
  let color = props.color || "blue";
  // let size = props.size || "24"
  return (
    <div className={`lds_spinner_${props.size}px ${color}`}>
      {Array.from(Array(12).keys(), (_, i) => (
        <div key={i}></div>
      ))}
    </div>
  );
};

export default Loader;
